import styled from "styled-components";
import { colors } from "../../../../consts";
import { Caption, Paragraph2 } from "../../../../components";

export const FeaturesControlWrapper = styled.div`
  border-top: 1px solid ${colors.RAISIN_20};
  margin-bottom: 16px;
  padding-top: 24px;

  ${Paragraph2} {
    font-weight: 700;
  }

  ${Caption} {
    font-size: 14px;
    font-weight: 400;
  }

  svg {
    path {
      fill: ${colors.RAISIN_100}!important;
    }
  }
`;

export const FeaturesHintWrapper = styled(Paragraph2)`
  text-align: center;
  font-weight: 500;
  color: ${colors.RAISIN_50};
`;
